module.exports = __webpack_public_path__ + "media/application/images/ui/icon-twitter-3d4f3a84f5f0110bd9d1ccd860080d5a.png";